import { useFirestoreNoCompagnyGeneralArrayContains } from '../firebase/useFirestore'
import { client } from './Client'

/**
 * De EIGEN deelname-rijen van dit huishouden: in welke programma's draait deze
 * organisatie mee, en met welke vragenlijst?
 *
 * `Members array-contains` is de poort van deze collectie. De rij van een ánder
 * lid komt hier terecht niet doorheen — en dat hoeft ook niet, want dit gaat
 * alleen over onze eigen meetgegevens. Zonder dat filter is het resultaat niet
 * leeg maar geweigerd, en dat leest als 'geen deelnemers'.
 * AI-CONTEXT: See docs/pitfalls.md#security-synchronisations-members-tenant-gate
 *
 * Eén bron voor beide afnemers — het vragenlijstpaneel én de poort van het
 * tabblad in een afspraak. Twee kopieën van dezelfde query lopen uiteen.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {string} householdKey - `Adresses.HouseholdKey`
 * @returns {Array<object>|undefined} `undefined` betekent 'nog niet geladen'
 */
const useHouseholdParticipations = (householdKey) =>
    useFirestoreNoCompagnyGeneralArrayContains(
        'HouseholdParticipations', 'HouseholdKey', householdKey || '', 'Members', client
    )

export default useHouseholdParticipations
